/**
 * Module dependencies.
 */

import { Card, CardMedia } from '@mui/material';
import { Description } from 'components/atoms/description/description';
import styled from '@emotion/styled';

/**
 * Export `Section` styled component.
 */

export const Section = styled.section`
  background-color: white;
  padding: 80px 0;

  @media (max-width: 768px) {
    padding: 40px 0;
  }

  @media (max-width: 576px) {
    padding: 40px 0 0;
  }
`;

/**
 * Export `Container` styled component.
 */

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px;
`;

/**
 * Export `TitleWrapper` styled component.
 */

export const TitleWrapper = styled.div`
  text-align: center;
  margin-bottom: 40px;

  @media (max-width: 768px) {
    margin-bottom: 0;
  }
`;

/**
 * Export `Title` styled component.
 */

export const Title = styled.h2`
  font-size: 28px;
  font-weight: bold;
  color: #1f2937;
  margin-bottom: 12px;
`;

/**
 * Export `ServicesGrid` styled component.
 */

export const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  padding: 60px 20px 20px;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 820px) {
    grid-template-columns: repeat(2, 1fr);
    padding: 36px 10px 10px;
  }

  @media (max-width: 576px) {
    grid-template-columns: repeat(1, 1fr);
    padding: 36px 0px 10px;
  }
`;

/**
 * Export `ServiceCard` styled component.
 */

export const ServiceCard = styled(Card)`
  border-radius: 12px;
  display: grid;
  min-height: 320px;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
  grid-template-areas:
    'image'
    'title'
    'content';

  overflow: hidden;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);

  @media (max-width: 1024px) {
    min-height: 350px;
  }

  @media (max-width: 480px) {
    margin: 0 24px;
    grid-template-columns: 1fr;
    grid-template-areas:
      'image'
      'title'
      'content';
  }
`;

/**
 * Export `CardDescription` styled component.
 */

export const CardDescription = styled(Description)`
  font-size: 14px;
  color: #6b7280;
`;

/**
 * Export `CardImage` styled component.
 */

export const CardImage = styled(CardMedia)`
  height: 180px;
  object-fit: cover;
  border-bottom: 2px solid #e5e7eb;
`;
